/* eslint-disable no-unused-vars */
import VimeoPlayer from '@vimeo/player';
import youtubePlayer from 'youtube-player';

function extractYouTubeId(url) {
    let videoId;
    const regexes = [
        /youtu\.be\/([^&]+)/,
        /youtube\.com\/.*v=([^&]+)/,
        /youtube\.com\/embed\/([^?]+)/,
        /youtube\.com\/v\/([^?]+)/,
        /youtube\.com\/watch\?.*v=([^&]+)/
    ];

    for (let regex of regexes) {
        const match = url.match(regex);
        if (match) {
            videoId = match[1];
            break;
        }
    }

    return videoId;
}

function heroVideo() {
    const videoModalElement = document.getElementById('hero__mediaVideoWrapper');

    if (!videoModalElement) {
        return;
    }

    const videoContainer = document.getElementById('hero__mediaVideoPlayer');
    const videoPlatform = videoModalElement.getAttribute('data-video-type');
    let videoId = videoModalElement.getAttribute('data-video-id');

    if ( videoPlatform !== 'matterport') {
        if (videoPlatform === 'youtube' && !videoId) {
            const videoUrl = videoModalElement.getAttribute('data-video-url');
            if (videoUrl) {
                videoId = extractYouTubeId(videoUrl);
            }
        }
    
        if (!videoId) {
            return;
        }
    
        let player;
    
        if (videoPlatform === 'vimeo') {
            player = new VimeoPlayer(videoContainer, {
                id: videoId,
                autoplay: false,
                playsinline: true,
            });
        } else if (videoPlatform === 'youtube') {
            const youtubeDiv = document.createElement('div'); // Create a new div
            videoContainer.appendChild(youtubeDiv); // Append it to the main container
    
            player = youtubePlayer(youtubeDiv, { // Initialize the YouTube player on the new div
                videoId: videoId,
                playerVars: {
                    autoplay: 0,
                    playsinline: 1,
                },
            });
        }
    
        const videoPlayTarget = document.getElementById('hero__mediaVideoTarget');
    
        videoModalElement.appendChild(videoContainer);
    
        videoPlayTarget.addEventListener('click', () => {
            videoPlayTarget.classList.add('is-playing');
    
            if (videoPlatform === 'vimeo') {
                player.play();
            } else if (videoPlatform === 'youtube') {
                player.playVideo();
            }
        });
    }

}


/**
 * Function to run when this module is called from site.js
 */
const init = () => {
    heroVideo();
};

export default init;
